import { useGetEInvoicingIntegrationPdp } from '@features/eInvoicing/hooks/useGetEInvoicingIntegrationPdp'

import { getIsPdpPeppolStatusApplied } from '../../utils/eInvoices/getIsPdpPeppolStatusApplied'
import { getIsPdpPpfStatusApproved } from '../../utils/eInvoices/getIsPdpPpfStatusApproved'

interface UseIsPdpIntegrationActiveOptions {
  enabled?: boolean
}

export const useIsPdpIntegrationActive = ({ enabled = true }: UseIsPdpIntegrationActiveOptions = {}) => {
  const {
    eInvoiceIntegrationPdpStatus,
    eInvoiceIntegrationPdpScope,
    eInvoiceIntegrationPdpNetworkStatus,
    isProcessing,
  } = useGetEInvoicingIntegrationPdp({ enabled })

  const isPdpStatusActive = eInvoiceIntegrationPdpStatus === 'ACTIVE'
  const isPdpCustomerInvoicesEnabled = !!eInvoiceIntegrationPdpScope?.customerInvoicesEnabled
  const isPdpPpfStatusApproved = getIsPdpPpfStatusApproved(eInvoiceIntegrationPdpNetworkStatus)
  const isPdpPeppolStatusApplied = getIsPdpPeppolStatusApplied(eInvoiceIntegrationPdpNetworkStatus)

  const isPdpIntegrationActive =
    isPdpStatusActive && isPdpCustomerInvoicesEnabled && isPdpPpfStatusApproved && isPdpPeppolStatusApplied

  return { isPdpIntegrationActive, isLoading: isProcessing }
}
